import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";
const DegreeCertAttestationFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div>
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What is Degree Certificate Attestation and why is it required?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Degree Certificate Attestation is the process of verifying your
              degree’s authenticity so it is legally accepted abroad. It is
              required for:
              <ul>
                <li> Employment / Job Visa</li>
                <li> Higher Education Admission</li>
                <li> Migration / Residency Visa</li>
                <li> Professional Licensing</li>
                <li> Family Visa (for some countries)</li>
              </ul>
              Without attestation, foreign employers and universities will not
              accept your degree.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Which countries require degree certificate attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Most commonly:
              <ul>
                <li> UAE, Qatar, Kuwait, Saudi Arabia, Oman, Bahrain</li>
                <li> European countries (Apostille instead of attestation)</li>
                <li> Asian & African countries</li>
              </ul>
              Gulf countries are the strictest, requiring multiple verification
              levels.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Apostille processing take?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines depend on document type and verification required:
              <ul>
                <li> Personal documents: 1–3 working days</li>
                <li> Educational documents: 3–7 working days</li>
                <li> Commercial documents: 2–5 working days</li>
              </ul>
              Some agencies offer same-day and express Apostille depending on
              MEA workload.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> What is the process for degree certificate attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Depending on the destination country, the steps include:
              <b>
                For Gulf Countries (UAE, Qatar, Kuwait, Saudi, Oman, Bahrain):
              </b>
              <ul>
                <li> University Verification</li>
                <li> HRD / SDM Attestation</li>
                <li> MEA (Ministry of External Affairs) Attestation</li>
                <li> Embassy Attestation</li>
                <li> MOFA Attestation (destination country)</li>
              </ul>
              <br />
              For Apostille Countries (Europe / USA):
              <ul>
                <li> SDM / HRD</li>
                <li> MEA Apostille</li>
                <li> (No embassy attestation needed)</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does degree attestation take?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines vary by country:
              <ul>
                <li>
                  {" "}
                  <b>UAE / Qatar:</b> 7–15 working days
                </li>
                <li>
                  {" "}
                  <b>Kuwait / Oman:</b> 10–18 working days
                </li>
                <li>
                  <b> Saudi Arabia:</b> 12–25 working days (due to Saudi Culture
                  verification)
                </li>
                <li>
                  {" "}
                  <b>Apostille Countries:</b> 2–7 working days
                </li>
              </ul>
              Express services may be faster if available.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is HRD attestation mandatory for degree attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Not always. It depends on the country:
              <ul>
                <li>
                  {" "}
                  <b> Saudi Arabia:</b> YES (mandatory)
                </li>
                <li>
                  {" "}
                  <b>Kuwait:</b> Mostly required
                </li>
                <li>
                  {" "}
                  <b>UAE / Qatar / Oman:</b> HRD OR SDM is accepted
                </li>
                <li>
                  {" "}
                  <b>Apostille countries:</b> SDM is usually enough
                </li>
              </ul>
              Agencies will guide based on your destination country’s rules.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to submit original degree certificates?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—if you choose a Govt-recognized, ISO-certified attestation
              agency. <br />
              Always ensure:
              <ul>
                <li> Physical office exists</li>
                <li> Receipt is given for your documents</li>
                <li> Tracking system is provided</li>
                <li> WhatsApp or SMS updates</li>
              </ul>
              Avoid freelancers or individuals without a verified office.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How much does Apostille cost in Bangalore? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Costs depend on:
              <ul>
                <li> Country</li>
                <li> Embassy fees</li>
                <li> HRD/MEA charges</li>
                <li> Urgency level</li>
                <li> Agency service charge</li>
              </ul>
              <br />
              General range:
              <ul>
                <li> UAE / Qatar: ₹3,500 – ₹8,000</li>
                <li> Kuwait / Oman: ₹4,000 – ₹10,000</li>
                <li> Saudi: ₹8,000 – ₹18,000</li>
                <li> Apostille: ₹1,500 – ₹4,000</li>
              </ul>
              Always ask for a complete breakdown.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can I get degree attestation done without visiting the office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many Bangalore-based professional centers provide:
              <ul>
                <li> Free home pickup & drop</li>
                <li> WhatsApp updates</li>
                <li> Online payment</li>
                <li> Digital tracking</li>
              </ul>
              Highly convenient for working professionals.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                {" "}
                What are the common issues that delay degree certificate
                attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Customers often face delays due to:
              <ul>
                <li> Name mismatch between passport & certificate</li>
                <li> Laminated degree certificates</li>
                <li> Incomplete university verification</li>
                <li> Fake or unapproved university degrees</li>
                <li> Missing transcripts</li>
                <li> Submitting photocopies instead of originals</li>
                <li> Wrong attestation route for the destination country</li>
              </ul>
              A good agency checks these beforehand to avoid rejection.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default DegreeCertAttestationFaqMain;
